import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

const Useauth = () => {
    const token = sessionStorage.getItem('token');
    return token != null;
}

const Auth = () => {
    const isAuth = Useauth();

    return isAuth ? <Outlet /> : <Navigate to="/login" />;
}

export default Auth;